import React from 'react';

import { SiteConfigManager } from '@atlas/core';

import MenuFooterItem from './MenuFooterItem';
import MenuFooterPaymentsListItem from './MenuFooterPaymentsListItem';

const MenuFooterPaymentsList = () => {
  const methods = SiteConfigManager.getConfig('config.config.payment.method_list', []);
  const filteredMethods = methods.filter(item => item.visible);

  const canRenderList = filteredMethods.length > 0;

  return (
    <MenuFooterItem className="payment-methods" title="footer_title_payment_methods">
      {canRenderList && (
        <div className="payment-methods__list">
          {filteredMethods.map(({ icon, type }) => (
            <MenuFooterPaymentsListItem icon={icon} key={icon} type={type} />
          ))}
        </div>
      )}
    </MenuFooterItem>
  );
};

export default MenuFooterPaymentsList;
